/* 2009-2019 Copyright Ridecell Inc. All rights reserved. */
import ValidationInterface, { Validation } from './Validation/Validation'

export const init = configObject => Object.assign(Validation, { messages: configObject.messages })

export const applyInterfaceFunction = functionName => (...args) =>
  ValidationInterface[functionName](...args)

export default {
  and: applyInterfaceFunction('and'),
  arrayOf: applyInterfaceFunction('arrayOf'),
  between: applyInterfaceFunction('between'),
  bool: applyInterfaceFunction('bool'),
  coordinate: applyInterfaceFunction('coordinate'),
  currency: applyInterfaceFunction('currency'),
  custom: applyInterfaceFunction('custom'),
  date: applyInterfaceFunction('date'),
  eq: applyInterfaceFunction('eq'),
  file: applyInterfaceFunction('file'),
  gt: applyInterfaceFunction('gt'),
  gte: applyInterfaceFunction('gte'),
  id: applyInterfaceFunction('id'),
  init,
  instanceOf: applyInterfaceFunction('instanceOf'),
  integer: applyInterfaceFunction('integer'),
  lt: applyInterfaceFunction('lt'),
  lte: applyInterfaceFunction('lte'),
  moment: applyInterfaceFunction('moment'),
  nonZeroCurrency: applyInterfaceFunction('nonZeroCurrency'),
  nonZeroPositiveInteger: applyInterfaceFunction('nonZeroPositiveInteger'),
  nullableOf: applyInterfaceFunction('nullableOf'),
  number: applyInterfaceFunction('number'),
  oneOf: applyInterfaceFunction('oneOf'),
  optionalOf: applyInterfaceFunction('optionalOf'),
  or: applyInterfaceFunction('or'),
  percentage: applyInterfaceFunction('percentage'),
  positiveFloat: applyInterfaceFunction('positiveFloat'),
  positiveInteger: applyInterfaceFunction('positiveInteger'),
  required: applyInterfaceFunction('required'),
  shape: applyInterfaceFunction('shape'),
  string: applyInterfaceFunction('string'),
  whenThen: applyInterfaceFunction('whenThen'),
}
